export default "__VITE_ASSET__l4458Zcc__"